import React, { useState } from "react";
import "../App.css";


const DisplayBox64Bit = ({ answerLeft, answerRight }) => {

    
      return (
        <>
          <div className="border-solid border-black border-2 p-1 m-1 h-9">
                <p>{answerLeft+" "+answerRight}</p>
            </div>
        </>
      );
    };
    
    export default DisplayBox64Bit;